import { useEffect, useState } from "react";
import api from "../api/api";
import { ENDPOINTS } from "../api/endpoints";

let countryCache = null;
let countryPromise = null;

const useCountryCodes = () => {
  const [countries, setCountries] = useState(countryCache || []);
  const [loading, setLoading] = useState(!countryCache);

  useEffect(() => {
    if (countryCache) {
      setCountries(countryCache);
      setLoading(false);
      return;
    }

    if (!countryPromise) {
      countryPromise = api
        .get(ENDPOINTS.getCountryCodes())
        .then((response) => {
          const result = response.data;

          if (result?.status === "Success") {
            const rawList = result.data || [];
            const normalized = rawList.map((c) => ({
              ...c,
              isO2: c.isO2 || c.iso2 || c.countryCode || c.ISO2 || "",
              dialCode: c.dialCode || c.callingCode || c.phoneCode || "",
            }));

            countryCache = normalized;
            return countryCache;
          }

          countryCache = [];
          return countryCache;
        })
        .catch((error) => {
          console.error("Failed to load country codes:", error);
          countryPromise = null;
          return [];
        });
    }

    countryPromise.then((data) => {
      setCountries(data);
      setLoading(false);
    });
  }, []);

  return {
    countries,
    loading,
  };
};

export default useCountryCodes;